import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeOrderInstructionGroupResponse from "./chargeOrderInstructionGroupResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeOrderInstructionGroupsResponse {
  /**
   * The list of instructions for vehicles.
   */
  @observable
  @Type(() => ChargeOrderInstructionGroupResponse)
  items!: ChargeOrderInstructionGroupResponse[];
}
